export default __webpack_public_path__ + "static/map-shape2-fa85069bd94dd20ba12b01be735d93bd.png";